/*
 * @Author: Lina
 * @Date: 2020-04-15 10:48:41
 * @LastEditors: Lina
 * @LastEditTime: 2020-07-09 20:50:17
 */
import _ from 'lodash';

export const PNAME = (typeof window !== 'undefined') && `${window.location.pathname !== '/' ? window.location.pathname.split('/buildingBlockResource/')[1] : ''}`;
export function isProduction() {
  return (typeof window !== 'undefined') && window.location.host === 'static.ccrgt.com'
}
export const BASEURL = isProduction() ? 'https://static.ccrgt.com' : 'https://t-static.ccrgt.com';
export function trackPV(EventID) {
  const query = parseUrlQuery();
  const { channelId, ADV_ID, itemId } = query;
  window.CRGTA.Event.trackPV({
    EventID,
    Body: {
      ACTID: `${PNAME}`,
      channelId: _.isNil(channelId) ? null : channelId,
      ADV_ID, itemId
    },
  });
}

export function trackClick(EventID, others = {}) {
  const query = parseUrlQuery();
  const { channelId, ADV_ID, itemId } = query;
  window.CRGTA.Event.trackClick({
    EventID,
    Body: {
      ACTID: `${PNAME}`,
      channelId: _.isNil(channelId) ? null : channelId,
      ADV_ID, itemId,
      ...others,
    },
  });
}


export function parseUrlQuery() {
  if ((typeof window !== 'undefined')) {
    let searchParams = !_.isEmpty(window.location.search.slice(1)) && window.location.search.slice(1).split('&');
    let hashObject = window.location.hash.slice(2);
    let hashParams = []
    if (!_.isEmpty(hashObject)) {
      if (!_.isEmpty(hashObject.split('?')) && !_.isEmpty(hashObject.split('?')[1])) {
        hashParams = hashObject.split('?')[1].split('&')
      }
    }
    let params = _.isEmpty(searchParams) ? hashParams : searchParams.concat(hashParams);
    let query = {}
    for (let i = 0; i < params.length; i++) {
      const pair = params[i].split('=');
      query[`${pair[0]}`] = decodeURIComponent(pair[1])
    }
    return query;
  }
}

/**
 * 是否登录
 */
export async function isLogged() {
  const token = await window.crgt.getToken();
  return !!token;
}

// 运营活动埋点
export function trackPVByActivity(EID,others) {
  const query = parseUrlQuery();
  const { ADV_ID, itemId } = query;
  window.CRGTA.Event.trackPV({
    Body: {
      EID,
      ACTID: '148', // 活动Id
      ADV_ID, itemId,
      ...others,
    },
  }, true);
}

export function trackClickByActivity(EID, others) {
  const query = parseUrlQuery();
  const { ADV_ID, itemId } = query;
  window.CRGTA.Event.trackClick({
    Body: {
      EID,
      ACTID: '148',  // 活动Id
      ADV_ID, itemId,
      ...others,
    },
  }, true);
}

export function downLoadPage(){
  const downloadUrl = `${BASEURL}/download/`
  window.location.href = downloadUrl;
}
